import React from 'react';
import Lottie from 'lottie-react';

import {
    Row,
    Col
} from 'antd';
import animation from './error.json';
function ErrorIndex(props) {

    return <section className={'error-page align-middle'}>
        <div className={'container'}>
            <Row>
                <Col span={24}>
                    <div className={'error-page__lottie-container'}>
                        <Lottie
                            animationData={animation}
                            loop={false}
                        />
                    </div>
                </Col>
                {
                    props?.error && <Col span={24}>
                        <h3>با عرض پوزش، در فرآیند مورد نظر شما خطایی رخ داده است</h3>
                        <p className={'error-page__message'}>
                            {props.error.message}
                        </p>
                    </Col>
                }
            </Row>
        </div>
    </section>
}

export async function getStaticProps() {
    return {
        props: {
            layout: 'clear',
            requirementCheck: false
        }
    }
}
export default ErrorIndex;
